module.exports = __webpack_public_path__ + "img/content-duplicate.9e41b9ec.svg";